module.exports = __webpack_public_path__ + "img/25-avatar male.66da7de8.png";